export default __webpack_public_path__ + "static/media/asics-M.d64b5e77.png";